var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"marquee-wrap",staticClass:"marquee-wrap"},[_c('div',{ref:"scroll",staticClass:"scroll"},[_c('p',{staticClass:"marquee"},[_vm._v(_vm._s(_vm.val))])]),_c('p',{ref:"getWidth",staticClass:"getWidth"},[_vm._v(_vm._s(_vm.val))])])
}
var staticRenderFns = []

export { render, staticRenderFns }